var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-creator-radio",class:_vm.answerContainerClass},[_c('p',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"pre",class:_vm.answerClass,domProps:{"innerHTML":_vm._s(_vm.answer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }